<template>
  <div class="kpi-card">
    <!-- Estado sin datos -->
    <div
      v-if="value === 0 && previous === 0"
      class="kpi-no-data"
      role="status"
      aria-live="polite"
    >
      <div class="kpi-no-data-illustration">
        <ion-icon name="trending-up-outline" />
      </div>
      <h3 class="kpi-no-data-title">Sin datos en este rango</h3>
      <p class="kpi-no-data-text">Ajusta fechas o cambia la línea para ver información.</p>
    </div>

    <!-- Estado con datos -->
    <template v-else>
      <!-- HEADER -->
      <div class="kpi-header">
        <ion-icon :name="icon" class="kpi-icon" />
        <div class="kpi-text">
          <h3 class="kpi-title">{{ title }}</h3>
          <p class="kpi-subtitle">{{ subtitle }}</p>
        </div>
      </div>

      <!-- VALORES -->
      <div class="kpi-values">
        <div class="kpi-current">
          {{ formattedValue }}
          <span v-if="suffix" class="kpi-suffix">{{ suffix }}</span>
        </div>

        <div class="kpi-change" :class="changeClass">
          <ion-icon
            v-if="change !== 0"
            :name="change > 0 ? 'arrow-up-outline' : 'arrow-down-outline'"
          />
          <span>{{ Math.abs(change) }}%</span>
        </div>
      </div>

      <!-- Anterior -->
      <p class="kpi-previous">Anterior: {{ previous }}{{ suffix ? ' ' + suffix : '' }}</p>
    </template>
  </div>
</template>

<script>
export default {
  name: 'KPI',
  props: {
    icon: { type: String, required: true },
    title: { type: String, required: true },
    subtitle: { type: String, required: true },
    value: { type: Number, required: true },
    previous: { type: Number, required: true },
    change: { type: Number, required: true },
    suffix: { type: String, default: '' }
  },
  computed: {
    formattedValue() {
      return this.value.toLocaleString('es-MX')
    },
    changeClass() {
      if (this.change > 0) return 'positive'
      if (this.change < 0) return 'negative'
      return ''
    }
  }
}
</script>

<style scoped>
.kpi-card {
  background-color: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 1.25rem;
  padding: 1.2rem;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.04);
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-family: 'Manrope', sans-serif;
}

/* ICONO + TÍTULO */
.kpi-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.kpi-icon {
  font-size: 1.8rem;
  color: #3b82f6;
}

.kpi-text {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.kpi-title {
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  margin: 0;
}

.kpi-subtitle {
  font-size: 0.88rem;
  font-weight: 500;
  color: #64748b;
  margin: 0.15rem 0 0;
}

/* VALORES PRINCIPALES */
.kpi-values {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15%;
}

.kpi-current {
  font-size: 1.8rem;
  font-weight: 800;
  color: #0f172a;
}

.kpi-suffix {
  font-size: 0.9rem;
  font-weight: 500;
  color: #475569;
  margin-left: 0.25rem;
}

.kpi-change {
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}

.kpi-change.positive {
  color: #16a34a;
}

.kpi-change.negative {
  color: #dc2626;
}

/* ANTERIOR */
.kpi-previous {
  font-size: 0.85rem;
  color: #94a3b8;
  margin: 0;
  font-weight: 500;
}

/* ====== NO DATA KPI ===== */
.kpi-no-data {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100px;
  padding: 1rem;
  gap: 0.5rem;
  font-family: 'Manrope', sans-serif;
  text-align: center;
  background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
  border: 2px dashed #e2e8f0;
  border-radius: 1rem;
}

.kpi-no-data-illustration {
  width: 48px;
  height: 48px;
  border-radius: 9999px;
  background: #eef2ff;
  display: grid;
  place-items: center;
  box-shadow: inset 0 0 0 1px #e2e8f0;
}

.kpi-no-data-illustration ion-icon {
  font-size: 1.4rem;
  color: #64748b;
}

.kpi-no-data-title {
  margin: 0;
  font-weight: 700;
  font-size: 0.95rem;
  color: #0f172a;
}

.kpi-no-data-text {
  margin: 0;
  font-weight: 500;
  font-size: 0.85rem;
  color: #64748b;
}

</style>